import React, { useEffect, useState } from "react";
import DeleteIcon from "../../../styles/svg/delete-icon.svg";
import useCustomMutate from "../../../hooks/useMutate";
import { deleteJobs, getJobDeleteStatus } from "../../../sevices/jobApi";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { moldInspectionServices } from "../../../utils/constants";

function DeleteTicket({ params }) {
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState(false);
  const defaultMessage = "Are you sure you want to delete this ticket?";
  const [message, setMessage] = useState(defaultMessage);
  const [statusLoading, setStatusLoading] = useState(false);
  const { mutate } = useCustomMutate(deleteJobs, ["jobs"], () => {
    setLoading(false);
    setDialog(false);
  });
  const Delete = () => {
    setLoading(true);
    mutate(params.row.job_id);
  };
  useEffect(() => {
    if (!dialog || !moldInspectionServices.includes(params.row.service_id)) {
      setMessage(defaultMessage);
      setStatusLoading(false);
      return;
    }

    const fetchDeleteStatus = async () => {
      setStatusLoading(true);
      try {
        const response = await getJobDeleteStatus(params.row.job_id);
        setMessage(response?.data?.message || defaultMessage);
      } catch (error) {
        setMessage(defaultMessage);
      } finally {
        setStatusLoading(false);
      }
    };

    fetchDeleteStatus();
  }, [dialog, params.row.job_id]);
  return (
    <div>
      {dialog && (
        <ConfirmationDialog
          open={dialog}
          handleClose={() => setDialog(false)}
          message={statusLoading ? "Loading..." : message}
          callback={Delete}
          loading={loading}
          btnTitle={"Delete"}
          title={"Delete Ticket"}
          btnColor="var(--dark-light-error, #B71D18)"
        />
      )}
      <img
        src={DeleteIcon}
        onClick={() => setDialog(true)}
        className="mr-1 cursor-pointer "
      />
    </div>
  );
}

export default DeleteTicket;
